import React, { Suspense } from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import { getDefaultMeasurementUnit } from '../../lib/size';
import * as types from '../../types';
import Loading from '../Loading';
import { SimpleDismissableModal } from '../modals';
import styles from './HardwareFirstSizingModal.module.scss';

const HardwareFirstSizingGuide = React.lazy(() => import('./HardwareFirstSizingGuide'));

interface HardwareFirstSizingModalProps {
  onOpen?: () => void;
  onSelect: (size: types.SizeOption) => void;
  trigger: JSX.Element;
}

/**
 * "Which size is right for my dog?" on the hardware-first size step: the breed and weight finder
 * with the recommendation and every band's measurements. Picking the recommended size closes the
 * sheet, since the step behind it shows the choice.
 */
export default function HardwareFirstSizingModal({ onOpen, onSelect, trigger }: HardwareFirstSizingModalProps) {
  const { country } = useLocale();

  return (
    <SimpleDismissableModal
      closeIconClassName={styles.closeIcon}
      containerClassName={styles.modal}
      onOpen={onOpen}
      trigger={trigger}
    >
      {(close) => (
        <Suspense fallback={<Loading />}>
          <HardwareFirstSizingGuide
            measurementUnit={getDefaultMeasurementUnit(country)}
            onSelect={(size) => {
              onSelect(size);
              close();
            }}
          />
        </Suspense>
      )}
    </SimpleDismissableModal>
  );
}
